export default __webpack_public_path__ + "static/media/instagram-4-512-round.5ba0ccd9.png";